export default __webpack_public_path__ + "static/09.02-488126430d1241e8a8231aa6cc206db7.png";